import { create } from 'zustand'

interface SearchFilterVisibilityState {
  isVisible: boolean
  setVisible: (visible: boolean) => void
}

export const useSearchFilterVisibility = create<SearchFilterVisibilityState>(set => ({
  isVisible: true,
  setVisible: (visible: boolean) => set({ isVisible: visible }),
}))
